import * as React from "react";
import {
  Button,
  MessageBarBody,
  MessageBar,
  MessageBarActions,
  Text,
  Link,
  tokens,
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogTrigger,
} from "@fluentui/react-components";
import { bundleIcon, DismissFilled, DismissRegular } from "@fluentui/react-icons";

import PrimaryButton from "../components/PrimaryButton";

import { ErrorContext } from "../store/error-context-api";
import { selectCell } from "../../helpers/utils";
import { useIconButtonStyles } from "../styles/styles";
import { format } from "date-fns";

import { dateFormat } from "../../helpers/utils";

const CloseBtnIcon = bundleIcon(DismissFilled, DismissRegular);

const Message = ({ message, time, intent, errorIdx = null, sheetName = null, address = null, todo = null }) => {
  const { deleteError } = React.useContext(ErrorContext);
  const iconStyles = useIconButtonStyles();

  const cellAddress = sheetName && address && sheetName + address;

  return (
    <MessageBar intent={intent}>
      <MessageBarBody className="flex flex-col flex-wrap p-[0.5rem]">
        <div className="flex justify-between">
          <div className="flex flex-col">
            <Text size={200}>{message}</Text>
            {todo && (
              <Text style={{ color: tokens.colorNeutralForeground3 }} size={100}>
                {todo}
              </Text>
            )}
          </div>
          <div className="flex flex-col">
            {cellAddress && (
              <Link
                appearance="subtle"
                onClick={async (_e) => await selectCell(sheetName, address)}
                inline
                style={{
                  fontSize: "12px",
                  alignSelf: "end",
                  textDecoration: "none",
                }}
              >
                {sheetName} {address}
              </Link>
            )}
            <Text style={{ color: tokens.colorNeutralForeground3 }} size={100}>
              {time}
            </Text>
          </div>
        </div>
      </MessageBarBody>
      {intent !== "info" && (
        <MessageBarActions
          containerAction={
            <Button
              className={iconStyles.dark}
              onClick={() => deleteError(errorIdx)}
              appearance="transparent"
              icon={<CloseBtnIcon />}
            />
          }
        />
      )}
    </MessageBar>
  );
};

export default function ErrorMessageDialog({ open, setOpen }) {
  const { errors, clearErrors } = React.useContext(ErrorContext);

  const isErrors = errors.length > 0;

  return (
    <Dialog
      open={open}
      onOpenChange={(_event, data) => {
        setOpen(data.open);
      }}
      modalType="alert"
    >
      <DialogSurface className="w-[90vw] max-w-[90vw]">
        <DialogBody>
          <DialogTitle>Error messages</DialogTitle>
          <DialogContent>
            <div className="flex flex-col gap-[0.3rem]">
              {isErrors ? (
                errors.map((error, errorIdx) => (
                  <Message
                    key={errorIdx}
                    message={error.msg}
                    todo={error.todo}
                    time={error.timestamp}
                    sheetName={error.sheetName}
                    address={error.address}
                    intent="error"
                    errorIdx={errorIdx}
                  />
                ))
              ) : (
                <Message time={format(Date.now(), dateFormat)} message={"There are no errors"} intent="info" />
              )}
            </div>
          </DialogContent>

          <DialogActions>
            <Button className="self-end" disabled={!isErrors} onClick={clearErrors} type="button">
              Clear
            </Button>
            {/* DialogTrigger inside of a Dialog still works properly */}
            <DialogTrigger disableButtonEnhancement>
              <PrimaryButton>Close</PrimaryButton>
            </DialogTrigger>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
